import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=dced447c&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=dced447c&prod&scoped=true&lang=css"
import style1 from "./Announcement.vue?vue&type=style&index=1&id=dced447c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dced447c",
  null
  
)

export default component.exports